import { DayKey, FoodNutrients, MealKey, MealPlanNutrition, WeeklyMealPlan } from '../types/mealPlan';
export const nutrientKey = (day: DayKey, meal: MealKey, index: number) => `${day}_${meal}_${index}`;

// Movimenta a composição junto ao item removido/reordenado e invalida texto editado.
export function reconcileFoodNutrients(before: WeeklyMealPlan, after: WeeklyMealPlan, nutrition: MealPlanNutrition): MealPlanNutrition {
  const result: MealPlanNutrition = {};
  (Object.keys(after) as DayKey[]).forEach(day => {
    (Object.keys(after[day]) as MealKey[]).forEach(meal => {
      const used = new Set<number>();
      after[day][meal].forEach((text, index) => {
        if (!text.trim()) return;
        const previous = before[day][meal].findIndex((item, oldIndex) => !used.has(oldIndex) && item === text && nutrition[nutrientKey(day, meal, oldIndex)]?.text === text);
        if (previous < 0) return;
        used.add(previous);
        result[nutrientKey(day, meal, index)] = nutrition[nutrientKey(day, meal, previous)];
      });
    });
  });
  return result;
}

export function getDayNutrition(plan: WeeklyMealPlan, nutrition: MealPlanNutrition, day: DayKey) {
  const totals: FoodNutrients = { calories: 0, protein: 0, carbs: 0, fats: 0 };
  let items = 0, knownItems = 0;
  (Object.keys(plan[day]) as MealKey[]).forEach(meal => plan[day][meal].forEach((text, index) => {
    if (!text.trim()) return;
    items++;
    const value = nutrition[nutrientKey(day, meal, index)];
    if (!value || value.text !== text || !Object.keys(totals).every(key => Number.isFinite(value[key as keyof FoodNutrients]) && value[key as keyof FoodNutrients] >= 0)) return;
    knownItems++;
    (Object.keys(totals) as Array<keyof FoodNutrients>).forEach(key => { totals[key] += value[key]; });
  }));
  return { totals, items, knownItems, complete: items > 0 && items === knownItems };
}
